// extracted by mini-css-extract-plugin
export default {"page":"bX-z","cartModal":"cX-z","checkout":"dX-z","placeholder":"eX-z","account":"fX-z"};